import React, { useState } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import projectsData from "../data/projects.json";

export default function Proyects() {
  const novels = projectsData.filter(p => p.type === "Novela" && p.show === 1);
  const events = projectsData.filter(p => p.type === "Evento" && p.show === 1);

  const [isNovelOpen, setIsNovelOpen] = useState(false);
  const [isEventOpen, setIsEventOpen] = useState(false);

  return (
  <>
    <HelmetProvider>
      <Helmet>
        <title>Proyectos | ERI</title>
      </Helmet>
    </HelmetProvider>
    <div id="projects" className="content">
      <div className="content-wrapper">
        <div className="content-title">
          <h1 className="title">Proyectos</h1>
          <p className="subtitle">
            Aquí podrás encontrar todos nuestros proyectos, tanto los que están ya disponibles como los futuros.<span className="break">A través de todo nuestro contenido disponible podrás conocer el universo de ERI.</span>
          </p>
        </div>
        <div className="content-main">
          {novels.length > 0 && (
            <div className="category-wrapper">
              <div className={`category toggle ${isNovelOpen ? "close" : ""}`} onClick={() => setIsNovelOpen(!isNovelOpen)}>Novelas</div>
              <div className="items" style={isNovelOpen ? { display: 'none' } : { display: 'grid' }}>
                {novels.map((project) => (
                  <div key={project.title} className="item">
                    {project.hasBanner && (
                      <img
                        className="img"
                        alt={project.title}
                        src={`${process.env.PUBLIC_URL}/img/projects/${project.id}.png`}
                      />
                    )}
                    <div className="item-content">
                      <div>
                        <div className="title">{project.title}</div>
                        <div className="text">
                          {project.description.split("\n").map((line, index) => (
                            <React.Fragment key={index}>
                              {line}
                              <br />
                            </React.Fragment>
                          ))}
                        </div>
                      </div>
                      <div className="info novel">
                        <div className="description">
                          {project.level && <>{`Nivel: ${project.level}`}<br /></>}
                          {project.duration && <>{`Duración: ${project.duration}`}<br /></>}
                          {project.players && <>{`Jugadores: ${project.players}`}<br /></>}
                        </div>
                        {project.enable ? (
                          <a className="btn btn-primary" href={project.url} target="_blank" rel="noopener noreferrer">
                            {project.buttonText}
                          </a>
                        ) : (
                          <button className="btn btn-primary disable" disabled>
                            {project.buttonText}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {events.length > 0 && (
            <div className="category-wrapper">
              <div className={`category toggle ${isEventOpen ? "close" : ""}`} onClick={() => setIsEventOpen(!isEventOpen)}>Eventos</div>
              <div className="items" style={isEventOpen ? { display: 'none' } : { display: 'grid' }}>
                {events.map((project) => (
                  <div key={project.id} className="item">
                    {project.hasBanner && (
                      <img className="img" alt={project.title} src={`${process.env.PUBLIC_URL}/img/projects/${project.id}.png`} />
                    )}
                    <div className="item-content">
                      <div>
                        <div className="title">{project.title}</div>
                        <div className="text">
                          {project.description.split("\n").map((line, index) => (
                            <React.Fragment key={index}>
                              {line}
                              <br />
                            </React.Fragment>
                          ))}
                        </div>
                      </div>
                      <div className="info">
                        <div className="description">
                          {project.level && <>{`Nivel: ${project.level}`}<br /></>}
                          {project.duration && <>{`Duración: ${project.duration}`}<br /></>}
                          {project.players && <>{`Jugadores: ${project.players}`}<br /></>}
                          {project.type && <>{`Tipo: ${project.typeDesc}`}<br /></>}
                        </div>
                        {project.enable ? (
                          <a className="btn btn-primary" href={project.url} target="_blank" rel="noopener noreferrer">
                            {project.buttonText}
                          </a>
                        ) : (
                          <button className="btn btn-primary disable" disabled>
                            {project.buttonText}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  </>
  );
}
